import { DatePipe } from '@angular/common';
import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { BillingserviceService } from '../billingService.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { ServiceList } from '../Models/billing.Models';
import { BillingFormModel, ReciptFormModel, RefundFormModel } from '../Models/billdetail.model';
import { MatDialog } from '@angular/material/dialog';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { BranchMatserService } from 'app/masters/branch-matser.service';


@Component({
  selector: 'app-refund',
  templateUrl: './refund.component.html',
  styleUrls: ['./refund.component.scss']
})
export class RefundComponent implements OnInit {
  todaysdate: any
  displayedColumns: string[] = ['serviceName', 'rate', 'qty', 'maxDiscountLimit', 'discount', 'serviceCharge', 'netAmount', 'serviceId'];
  dataSource = new MatTableDataSource<ServiceList>();
  destroy$: Subject<boolean> = new Subject<boolean>();
  BillingData: BillingFormModel = {};
  ReciptData: ReciptFormModel = {};
  RefundData: RefundFormModel = {};
  RefundDataArray: any = [];
  RecieptIdForRefund: any;
  dyanmiccheck: boolean = false;
  cuurentTime: any;
  DipositeType: any = [];
  BnakType: any = [];
  PaymentType: any = [];
  MinimeDate: any;
  getRefundAmmount: number = 0;
  RefundId: number;
  showspinner = false;
  updaterefund: boolean = true;
  bankdetailelvel1: any = "Card/Cheque No.";
  bankdetailelvel2: any = "Card/Cheque Date";
  screenPermissionobj: any = {};
  getRefundReson: string = '';
  lockfield: boolean = true;
  refunddisable: boolean = false;
  isupdate: boolean = false;
  receiptDateandTime: any;
  show: boolean = true;
  RefdataPrint: any;
  constructor(public authService: AuthService, public dialog: MatDialog, public ipdService: IPDService,
    public dashboardService: DashboardService, private datePipe: DatePipe, public branchMatserService: BranchMatserService,
    public opdvisitService: OpdVisitService, public dialogRef: MatDialogRef<RefundComponent>,
    public router: Router, public billingservice: BillingserviceService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.rowClicked =-1;
    this.isupdate =false;
    this.getdipaymenttype();
    this.getbanktype();
    var data = this.data;
    this.receiptDateandTime = this.datePipe.transform(data.ReciptDataobj.PaymentDate, "dd/MM/YYYY") + '  ' + data.ReciptDataobj.PaymentTime;
    this.RecieptIdForRefund = data.recieptId
    this.setrefundformdata(data.ReciptDataobj, data);
    this.openRefundmodel(this.RecieptIdForRefund);
    this.MinimeDate = this.authService.getServerDate;
    this.RefundData.receiptNoFull = data.no;
    this.getproductmasterconfig();
    this.RefundId = null;

    this.getscreenPermission();
  }

  getscreenPermission() {
    this.screenPermissionobj = {};
    let userId = this.authService.Loggeduser.userid;
    this.billingservice.getbillingScreenPermission(userId).subscribe(data => {
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (element.screenName.toLowerCase() === 'refund') {
          this.screenPermissionobj = element;
        }

      }
    })
  }
  editbillingform() {
    if (this.screenPermissionobj?.modifyPermission === true) {
      document.getElementById("PateintrefundModel").style.display = "block";
      this.getRefundReson = '';
    } else {
      this.dashboardService.openSnackBar("you don't have permission to access this resource", "OK");
    }
  }

  billRefundupdateresons(a: any) {

    this.RefundData.RefundReason = '';
    if (this.getRefundReson) {
      this.RefundData.RefundReason = this.getRefundReson;
      this.lockfield = true;
      this.updaterefund = false;
      document.getElementById("PateintrefundModel").style.display = "none";
    } else {
      this.dashboardService.openSnackBar("Please Write your Reason", "OK");
    }

  }
  closeModificationModalDialog() {

    this.lockfield = false;
    document.getElementById("PateintrefundModel").style.display = "none";
  }
  checkNegative(value: any) {

    if (value >= 0) {
      return true
    } else {
      this.RefundData.RefundAmount = 0;
    }
  }

  getfinyearstring(finyearid: number) {
    return this.authService.FinYears.find(fy => fy.pkFinYearId == finyearid).displayFinYear;
  }


  closedialog() {
    this.dialogRef.close();
    // this.dialog.closeAll();
  }


  //   openModalDialog(data){
  //      document.getElementById("recipModel").style.display = "block";
  //   }

  //  closeModalDialog(){
  //  document.getElementById("recipModel").style.display = "none";

  //  }


  setrefundformdata(data, a) {
    this.cuurentTime = new Date().toTimeString().split(" ")[0];
    this.RefundData.FK_BranchId = parseInt(data.FK_BranchId);

    if (this.data.refundType == 'Advance Deposit') {
      this.RefundData.RefundType = 'A'
    } else {
      this.RefundData.RefundType = 'B'
      this.RefundData.Fk_BillId = this.data.billId;
    }
    this.RefundData.RefundDate = this.datePipe.transform(this.authService.getServerDate, "dd/MM/YYYY");
    this.RefundData.RefundTime = this.cuurentTime;
    this.RefundData.FK_ApprovedById = this.authService.Loggeduser.userid;
    this.RefundData.RefundReason = null;
    this.RefundData.FK_PayTypeId = parseInt(data.FK_PayTypeId);
    this.RefundData.FK_CurrencyId = parseInt(data.ConvertRetio)
    this.RefundData.CurrencyAmount = parseInt(a.Amount);
    this.RefundData.ConvertRetio = data.ConvertRetio;
    this.RefundData.RefundAmount = parseInt(a.netAmount);
    this.RefundData.ChequeNo = null;
    this.RefundData.ChequeDate = null;
    this.RefundData.FK_ChqBankId = null;
    this.RefundData.FK_CreatedById = this.authService.Loggeduser.userid;
    this.RefundData.IsActive = 1;
    this.RefundData.PK_RefundId = 0;
    if (this.RefundData.FK_PayTypeId === 2 || this.RefundData.FK_PayTypeId === 3 || this.RefundData.FK_PayTypeId === 6) {
      this.dyanmiccheck = true;
    }

  }


  getdiposittype() {
    this.billingservice.getdepositeType().subscribe(data => {
      this.DipositeType = data;
    })
  }

  getdipaymenttype() {
    this.billingservice.getpaymentType().subscribe(data => {
      this.PaymentType = data;
    })
  }

  getbanktype() {
    this.billingservice.getbankType().subscribe(data => {
      this.BnakType = data;
    })
  }



  saveRefunddetails() {

    if (this.RefundData.RefundReason) {
      this.cuurentTime = new Date().toTimeString().split(" ")[0];
      this.RefundData.FK_ReceiptId = this.RecieptIdForRefund;
      this.RefundData.FK_BranchId = parseInt(this.RefundData.FK_BranchId);
      this.RefundData.RefundType = this.RefundData.RefundType;
      this.RefundData.RefundDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
      this.RefundData.RefundTime = this.cuurentTime;
      this.RefundData.FK_ApprovedById = this.authService.Loggeduser.userid;
      this.RefundData.RefundReason = this.RefundData.RefundReason
      this.RefundData.FK_PayTypeId = parseInt(this.RefundData.FK_PayTypeId);
      this.RefundData.FK_CurrencyId = parseInt(this.RefundData.FK_CurrencyId)
      this.RefundData.CurrencyAmount = parseInt(this.RefundData.CurrencyAmount);
      this.RefundData.ConvertRetio = parseInt(this.RefundData.ConvertRetio);
      this.RefundData.RefundAmount = parseInt(this.RefundData.RefundAmount);
      this.RefundData.ChequeNo = this.RefundData.ChequeNo;
      this.RefundData.ChequeDate = this.RefundData.ChequeDate;
      this.RefundData.FK_ChqBankId = parseInt(this.RefundData.FK_ChqBankId);;
      this.RefundData.FK_CreatedById = this.authService.Loggeduser.userid;
      this.RefundData.IsActive = 1;
      if (this.RefundData.PK_RefundId == null || this.RefundData.PK_RefundId == undefined) {
        this.RefundData.PK_RefundId = 0;
      }

      console.log('refund', this.RefundData);
      switch (this.RefundData.RefundType) {
        case 'A': {
          if (this.RefundData.RefundAmount > 0) {
            if (this.data.netAmount >= this.RefundData.RefundAmount) {
              if (this.RefundData.FK_PayTypeId === 2 || this.RefundData.FK_PayTypeId === 3 || this.RefundData.FK_PayTypeId === 6 || this.RefundData.FK_PayTypeId === 7 || this.RefundData.FK_PayTypeId === 8) {
                if (this.RefundData.ChequeNo && (this.RefundData.FK_ChqBankId || this.show == false)) {
                  this.dyanmiccheck = false;
                  this.showspinner = true;
                  this.billingservice.addRefundDetails(this.RefundData).subscribe(data =>
                    this.success_refund_response(data), err => this.err_refund_response(err));
                }
                else {
                  this.dashboardService.openSnackBar("Please check all mandatory fields ", "ok");
                  return;
                }

              }

              else {
                this.dyanmiccheck = false;
                if (this.getRefundAmmount == this.RefundData.CurrencyAmount) {
                  this.dashboardService.openSnackBar("you can't refund more than", '0');
                  return;
                }

                else if (this.getRefundAmmount > this.RefundData.CurrencyAmount) {
                  this.dashboardService.openSnackBar("you can't refund more than", '0');
                  return
                }
                else {
                  this.showspinner = true;
                  this.billingservice.addRefundDetails(this.RefundData).subscribe(data =>
                    this.success_refund_response(data), err => this.err_refund_response(err));
                }
              }

            }
            else {
              this.dashboardService.openSnackBar("you can't refund more than  Deposit Amount", 'ok');


            }
          } else {
            this.dashboardService.openSnackBar("you can't refund Zero Amount", 'ok');
          }
          break;
        }
        case 'B': {
          var diffamount = this.data.Amount - this.data.billRefund;
          if (this.RefundData.RefundAmount > 0) {
            if (diffamount >= this.RefundData.RefundAmount) {
              if (this.RefundData.CurrencyAmount >= this.RefundData.RefundAmount) {
                if (this.RefundData.FK_PayTypeId === 2 || this.RefundData.FK_PayTypeId === 3 || this.RefundData.FK_PayTypeId === 6 || this.RefundData.FK_PayTypeId === 7 || this.RefundData.FK_PayTypeId === 8) {
                  if (this.RefundData.ChequeNo && (this.RefundData.FK_ChqBankId || this.show == false)) {
                    this.dyanmiccheck = false;
                    this.showspinner = true;
                    this.billingservice.addRefundDetails(this.RefundData).subscribe(data =>
                      this.success_refund_response(data), err => this.err_refund_response(err));
                  }
                  else {
                    this.dashboardService.openSnackBar("Please check all mandatory fields ", "ok");
                    return;
                  }

                }

                else {
                  this.dyanmiccheck = false;
                  if (this.getRefundAmmount == this.RefundData.CurrencyAmount) {
                    this.dashboardService.openSnackBar("you can't refund more than", '0');
                    return;
                  }

                  else if (this.getRefundAmmount > this.RefundData.CurrencyAmount) {
                    this.dashboardService.openSnackBar("you can't refund more than", '0');
                    return;
                  }
                  else {
                    this.showspinner = true;
                    this.billingservice.addRefundDetails(this.RefundData).subscribe(data =>
                      this.success_refund_response(data), err => this.err_refund_response(err));
                  }
                }

              }
              else {
                this.dashboardService.openSnackBar("you can't refund more than Deposit Amount ", 'ok');

              }
            }
            else {
              this.dashboardService.openSnackBar("you can't refund more than Deposit Amount ", 'ok')
            }
          } else {
            this.dashboardService.openSnackBar("you can't refund Zero Amount ", 'ok')
          }
        }
          break;
      }


    }
    else {
      this.dashboardService.openSnackBar("Please check all mandatory fields", "OK");
    }
  }

  success_refund_response(data) {
    this.showspinner = false;
    this.receiptDateandTime = "";
    this.RefundData = {};
    this.dashboardService.openSnackBar("Refund generated successfully", "OK");
    this.openRefundmodel(this.RecieptIdForRefund);
    // this.checkAmountleft();
    this.ngOnInit();

  }

  err_refund_response(err) {
    this.showspinner = false;
    // this.openRefundmodel(this.RecieptIdForRefund);
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  openRefundmodel(id: number) {
    // console.log(this.authService.Loggeduser.companyname)
    this.billingservice.getRefounofReciept(id).subscribe(data => {
      if (data.statusCode) {
      }
      else {
        this.RefundDataArray = data;
        // 
        this.getRefundAmmount = 0
        data?.forEach(element => {

          this.getRefundAmmount = this.getRefundAmmount + element.refundAmount;

        });
        console.log(this.getRefundAmmount);
        this.checkAmountleft();
      }

    })
  }

  closeRefundmodel() {
    //  this.RefoundModelBox = 'none';
  }


  chnagePaymentMode(e) {

    var value = e;
    if (value == 2 || value == 3 || value == 6) {
      this.dyanmiccheck = true;
      this.bankdetailelvel1 = "Card/Cheque No.";
      this.bankdetailelvel2 = "Card/Cheque Date";
      this.RefundData.ChequeNo = null;
      this.RefundData.ChequeDate = this.authService.getServerDate;;
      this.RefundData.FK_ChqBankId = null;
      this.show = true;
    } else if (value == 4 || value == 5 || value == 7 || value == 8) {
      this.dyanmiccheck = true;
      this.bankdetailelvel1 = "Transaction No.";
      this.bankdetailelvel2 = "Transaction Date";
      this.RefundData.ChequeNo = null;
      this.RefundData.ChequeDate = this.authService.getServerDate;;
      this.RefundData.FK_ChqBankId = null;
      if (value == 7) {
        this.show = false;
      } else {
        this.show = true;
      }

    }
    else {
      this.bankdetailelvel1 = "Card/Cheque No.";
      this.bankdetailelvel2 = "Card/Cheque Date";
      this.RefundData.ChequeNo = null;
      this.RefundData.ChequeDate = this.authService.getServerDate;;
      this.RefundData.FK_ChqBankId = null;
      this.dyanmiccheck = false;
      this.show = true;
    }
  }
  getproductmasterconfig() {
    let BranchId = this.authService.Loggeduser.branchid;
    this.billingservice.getproductionConfrigration(BranchId).subscribe(data => {
      //console.log('master confrigartion',data);
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (element.propertyName === "WebURL") {
          this.reporturl = element.propertyValue;
        }

      }
    })
  }

  reporturl(reporturl: any) {
    throw new Error('Method not implemented.');
  }
  prientRefund() {
    if (this.RefundId) {
      window.open(this.reporturl + 'Refund.aspx?RefundId=' + this.RefundId + '&BranchId=' + this.authService.Loggeduser.branchid + '&BillingCompanyName=' + this.authService.Loggeduser.billingcompanyname + '&PageHeadWebReport=' + 'Y');
    }
    else {
      this.dashboardService.openSnackBar("Please Select Refund Receipt ", "OK");
    }


  }


  failedurl(err) {
    this.dashboardService.openSnackBar("summary api url failed ", "OK");
  }


  selectRefunddata(id) {

    //this.updaterefund =false;
    const rowrefunddata = this.RefundDataArray.filter(item => item.pK_RefundId == id);
    if (rowrefunddata[0].fK_PayTypeId != null && rowrefunddata[0].fK_PayTypeId != undefined) {
      this.chnagePaymentMode(rowrefunddata[0].fK_PayTypeId)
    }
    this.receiptDateandTime = this.datePipe.transform(this.data.ReciptDataobj.PaymentDate, "dd/MM/YYYY") + '  ' + this.data.ReciptDataobj.PaymentTime;
    this.RefundData.PK_RefundId = rowrefunddata[0].pK_RefundId;
    this.RefundData.RefundDate = this.datePipe.transform(rowrefunddata[0].refundDate, "dd/MM/YYYY");
    this.RefundData.RefundTime = rowrefunddata[0].refundTime;
    this.RefundData.CurrencyAmount = rowrefunddata[0].currencyAmount;
    this.RefundData.FK_BranchId = rowrefunddata[0].fK_BranchId;
    this.RefundData.RefundAmount = rowrefunddata[0].refundAmount;
    this.RefundData.FK_PayTypeId = rowrefunddata[0].fK_PayTypeId;
    this.RefundData.RefundType = rowrefunddata[0].refundType;
    this.RefundData.ChequeNo = rowrefunddata[0].chequeNo;
    this.RefundData.ChequeDate = this.datePipe.transform(rowrefunddata[0].chequeDate, "dd/MM/YYYY");
    this.RefundData.FK_ChqBankId = rowrefunddata[0].fK_ChqBankId;
    this.RefundData.RefundReason = rowrefunddata[0].refundReason;
    this.RefundData.ConvertRetio = rowrefunddata[0].convertRetio;
    this.RefundData.FK_CreatedById = rowrefunddata[0].fK_CreatedById;
    this.RefundData.FK_CurrencyId = rowrefunddata[0].fK_CurrencyId
    this.RefundId = id;

  }

  rowClicked: any;
  changeTableRowColor(idx: any) {

    if (this.rowClicked === idx) {
      this.rowClicked = -1;
      this.ngOnInit();
      this.updaterefund = true;
      this.isupdate = false;
      this.lockfield = true;
      this.refunddisable = false;
    }
    else {
      this.isupdate = true;
      this.rowClicked = idx;
      this.lockfield = false;
      this.refunddisable = true;
    }
  }
  convertToDate(dateStr: string) {
    const [day, month, year] = dateStr.split('/');
    return year + '-' + month + '-' + day// month is 0-based
  }

  // update refund amount 
  updateRefunddetails(refundid: any) {
 
    if (refundid) {
      if (this.RefundData.RefundType == 'B') {
        this.RefundData.Fk_BillId = this.data.billId;
      }
      this.RefundData.FK_ReceiptId = this.RecieptIdForRefund;
      this.RefundData.PK_RefundId = refundid;
      this.RefundData.FK_ApprovedById = this.authService.Loggeduser.userid;
      this.RefundData.receiptNoFull = "";
      this.RefundData.IsActive = 1;
      if (this.RefundData.RefundAmount > 0) {
        if (this.RefundData.CurrencyAmount >= this.RefundData.RefundAmount) {
          this.RefundData.RefundDate = this.convertToDate(this.RefundData.RefundDate);
          this.showspinner = true;

          this.billingservice.addRefundDetails(this.RefundData).subscribe(data =>
            this.update_refund_response(data), err => this.err_refund_response(err));
        } else {
          this.dashboardService.openSnackBar("Refund Amount Less than Actual Amount", "OK");
        }

      } else {
        this.dashboardService.openSnackBar("Refund Amount More than Zero", "OK");
      }

    }
  }
  update_refund_response(data) {
    this.showspinner = false;
    this.dashboardService.openSnackBar("Refund Update successfully", "OK");
    this.openRefundmodel(this.RecieptIdForRefund);
    this.receiptDateandTime = "";
    this.RefundData = {};
    this.ngOnInit();
    // this.checkAmountleft();
  }

  checkAmountleft() {
    if (this.RefundDataArray.length > 0) {
      var checkamount = 0
      this.RefundDataArray.forEach(item => {
        checkamount = checkamount + item.refundAmount;
      });
      this.RefundData.RefundAmount = this.RefundData.CurrencyAmount - checkamount;
    }
  }


  branchmansterObj: any = {};
  getBranchDetail(id) {
    this.branchmansterObj = {};
    this.branchMatserService.getBrachMasterItem(id).subscribe((x: any) => {
      this.branchmansterObj = x[0];
    })
  }
  printTimeline() {

    let checkreporttype = this.authService.webreportConfig.filter(item => item.printOption == 'Credit Note' && item.printType == 'NetramReport');
    if (checkreporttype.length > 0) {
      this.prientRefund();
    } else {
      this.printTimelinedata();
    }

  }
  printTimelinedata() {
    if (this.RefundId > 0) {
      let payload = {
        "WebReportPrintMaster": {
          "module": "Billing",
          "printOption": "Credit Note",
          "printType": "WebNetramReport",
          "PRINTDATE": this.datePipe.transform(this.authService.localDate, "dd/MM/YYYY"),
          "PrintTime": this.convertTime12Hour(new Date()),
          "Pk_RegId": this.opdvisitService.patientdetails.pkRegId,
          "Pk_BillId": this.data.billId,
          "Pk_ReceiptId": this.RefundData.FK_ReceiptId,
          "Pk_BranchId": this.authService.Loggeduser.branchid,
          "Pk_LoggedUserId": this.authService.Loggeduser.userid,
          "Pk_RefundId": this.RefundId,
          "BILLINGCOMPANYNAME": this.authService.Loggeduser.billingcompanyname,
          "LINE1": this.branchmansterObj.line1,
          "LINE2": this.branchmansterObj.line2,
          "LINE3": this.branchmansterObj.line3,
          "LINE4": this.branchmansterObj.line4,
          "HOSPITALIMAGE": window.location.origin + '/' + this.authService.loginclientlogo,
          "COMPANYIMAGE": window.location.origin + '/' + this.authService.leftbottomlogosm,
          "CERTIFICATE1IMAGE": window.location.origin + '/' + + this.authService.nabhlogo,
          "CERTIFICATE2COMPANYIMAGE": '',
          "RefundArray": 'Y',
          "PatientRegistrationArray": 'Y',
          "PrintHeaderArray": 'Y',
        }

      }

      this.ipdService.GetWebReportPrint(payload).subscribe((x: any) => {
        if (x.length > 0) {
          let printContents, popupWin;
          printContents = x[0].printTemplate;
          popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
          popupWin.document.open();
          popupWin.document.write(`
        <html>
         
      <body onload="window.print();">${printContents}
      </body>
        </html>`
          );

          popupWin.document.close();


        } else {
          this.dashboardService.openSnackBar("Report Template Not Set", "OK");
        }
      }, err => {
        this.dashboardService.openSnackBar("Api Failed", "OK");
      })
    } else {
      this.dashboardService.openSnackBar("Please Select Id", "OK");
    }
  }
  timecheck: any;
  convertTime12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != '') {
      let hour = (this.timecheck.split(':'))[0]
      let min = (this.timecheck.split(':'))[1]
      let part = hour >= 12 ? 'PM' : 'AM';

      min = (min + '').length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + '').length == 1 ? `0${hour}` : hour;

      return (`${hour}:${min} ${part}`)
    } else {
      return null;
    }

  }

  formattimechange(appttime: string) {
    if (appttime == null) {
    } else {
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      return hr_min[0] + ":" + hr_min[1];
    }
  }
}
